<template>
  <div class="app">
    <generic-view
      :title="$t('system update wizard')"
      icon="wrench"
      v-bind:searchable="false"
    >
      <form-wizard
        :title="$t('system update')"
        :subtitle="$t('this wizard will guide you to update system')"
        :nextButtonText="$t('next')"
        :backButtonText="$t('back')"
        :finishButtonText="$t('finish')"
        shape="circle"
      >
        <tab-content icon="database icon" :title="$t('database')">
          <database-management />
        </tab-content>
        <tab-content icon="desktop icon" :title="$t('application')">
          <application-management />
        </tab-content>
      </form-wizard>
    </generic-view>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  success_toast,
  enterprise_setup,
  api_host,
} from "@/utils";
import GenericView from "@/components/GenericContainer";
import DatabaseManagement from "./SystemDatabaseManagement.vue";
import ApplicationManagement from "./ApplicationManagement.vue";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "SettingsSystemManagement",
  data() {
    return {
      processing: false,
      config: {},
      enterprises: [],
      api_host: api_host,
    };
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  components: {
    "generic-view": GenericView,
    DatabaseManagement,
    FormWizard,
    TabContent,
    ApplicationManagement,
  },
  watch: {},
  methods: {
    getData() {
      let vm = this;
      local_api(this, "post", "/system/do-get-login-config", {})
        .then((response) => {
          vm.enterprises = response.enterprises;
          if (response.config) this.config = JSON.parse(response.config);
          else
            this.config = {
              hide_enterprise_field: false,
              default_enterprise: "",
              logo: "",
            };

          let vls = response.enterprises.map((e) => {
            return { name: e.name, value: e.codename };
          });
          window
            .jQuery(vm.$refs.enterprise_dropdown)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.config.default_enterprise = value;
              },
            });

          if (this.config.default_enterprise) {
            window
              .jQuery(vm.$refs.enterprise_dropdown)
              .dropdown("set selected", this.config.default_enterprise);
          }

          if (this.config.logo) {
            console.log(this.config.logo);
          }
        })
        .catch((err) => {
          error_toast(err);
        })
        .finally(() => {
          vm.processing = false;
        });
    },
    save() {
      let vm = this;
      local_api(vm, "post", "/system/do-save-login-config", {
        config: JSON.stringify(vm.config),
      })
        .then(() => {
          success_toast(vm.$t("log in configuration set"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    this.getData();
    window
      .jQuery(this.$refs.tabs)
      .find(".item")
      .tab();
  },
};
</script>

<style>
.wizard-icon {
  margin-top: 30% !important;
}
</style>
